export const DEPLOYMENT_ROUTE_PATH = '/deployment';
